import { Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import PropertiesPage from './pages/PropertiesPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import AdminPanel from './pages/AdminPanel'
import AdminLogin from './pages/AdminLogin'

function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Ana layout ile sarılmış sayfalar */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="ilanlar" element={<PropertiesPage />} />
          <Route path="hakkimizda" element={<AboutPage />} />
          <Route path="iletisim" element={<ContactPage />} />
        </Route>
        
        {/* Admin login sayfası - layout dışında */}
        <Route path="/admin-login" element={<AdminLogin />} />
        
        {/* Gizli admin paneli - layout dışında */}
        <Route path="/admin-secret-panel-2024" element={<AdminPanel />} />
      </Routes>
    </>
  )
}

export default App